import { render, staticRenderFns } from "./ChallengerDetailDescription.vue?vue&type=template&id=47d4e31a"
import script from "./ChallengerDetailDescription.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailDescription.vue?vue&type=script&lang=ts"
import style0 from "./ChallengerDetailDescription.vue?vue&type=style&index=0&id=47d4e31a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports